import { http } from '../../../utils/http'
export const UABASE = window.$envUtils('VUE_APP_AFF_SERVICE')

// 表单集合查询
export const getFormList = (params) => {
  return http.get(`${UABASE}/formSetting/formList`, { params })
}
// 表单删除
export const deleteForm = (params) => {
  return http.delete(`${UABASE}/formSetting/form`, { params })
}
